import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessGoalsListRoute extends Route {
  @service store;

  beforeModel() {
    return Promise.all([
      this.store.findAll('person'),
      this.store.findAll('initiative'),
    ]);
  }

  model() {
    return this.modelFor('business.goals');
  }
}

export default instrumentRoutePerformance(BusinessGoalsListRoute);
